// Client-side ApiError class for frontend use
export class ApiErrorClient extends Error {
    status;
    constructor({ message, status }) {
        super(message);
        this.status = status;
        this.name = 'ApiError';
    }
}
// Server-side ApiError class for backend use
export class ApiErrorServer extends Error {
    statusCode;
    details;
    constructor(message, statusCode = 500, details) {
        super(message);
        this.statusCode = statusCode;
        this.details = details;
        this.name = 'ApiError';
    }
}
// Algorithm constants
export const BIN_INTERVALS = {
    0: 0, // Immediate
    1: 5, // 5 seconds
    2: 25, // 25 seconds
    3: 120, // 2 minutes
    4: 600, // 10 minutes
    5: 3600, // 1 hour
    6: 18000, // 5 hours
    7: 86400, // 1 day
    8: 432000, // 5 days
    9: 2160000, // 25 days
    10: 10368000, // 4 months
    11: null, // Never
    [-1]: null, // Hard to remember (never show)
};
export const MAX_INCORRECT_COUNT = 10;
//# sourceMappingURL=index.js.map